export default "__VITE_ASSET__6_i63l99__ 1620w, __VITE_ASSET__J1s7QaT6__ 820w, __VITE_ASSET__Vo5$o6xt__ 500w";